export default class Mask {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        return '9999';
    }

    birthdate() {
        return '2999-19-39';
    }
}
